import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

export const useIOSLimitations = () => {
  const { state } = useGlobalContext();
  const isIOSStripdownEnabled = state?.tenancy?.ios_stripdown;

  const isIOS = !!state?.isIOS;
  const isAppClient = !!state?.isMobileAppClient;

  const shouldEnableIOSLimitations =
    isIOS && isAppClient && isIOSStripdownEnabled;

  return {
    shouldEnableIOSLimitations,
  };
};
